import Mixin from '@ember/object/mixin';
import { inject as service } from '@ember/service';

export default Mixin.create({
  router: service(),

  actions: {
    _mix_cancelEdit(defaultCancel) {
      defaultCancel();
      this.router.transitionTo('user.projects.index');
    }
  }
});
